<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <div class="admin__header">
      <h1 class="page-title">Uredi Uporabnika</h1>
      <v-button class="delete-button" :disabled="isLoading" @click="onDelete" background-color="red" outlined>Izbriši</v-button>
    </div>
    <user-form v-show="!isLoading" @submit="submitUser" @delete="onDelete" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VButton from 'design-system/VButton.vue'
import UserForm from './forms/UserForm'
import prompt from 'design-system/components/prompt/prompt'

export default {
  props: {
    id: { type: [String, Number], required: true },
    accountId: { type: [String, Number], required: true },
  },
  components: {
    UserForm,
    VButton,
  },
  created () {
    this.initialize({ accountId: this.accountId, userId: this.id })
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('accountStore/users/forms', ['initialize', 'reset', 'submitUser', 'deleteUser']),
    async onDelete () {
      const result = await prompt.okText('Izbriši').confirm('Res želite izbrisati uporabnika? Akcija bo nepovratno izbrisala uporabnika, vsi njegovi dokumenti bodo prenešeni vam.')
      if (result) {
        this.deleteUser(this.id).then(() => this.$router.push({ name: 'account_users_path' }))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/admin_common';
@import '@/components/common';
</style>
